import { Box, Button, Divider, InputAdornment, MenuItem, Stack, TextField, Typography } from "@mui/material";

import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { useState } from "react";
const states = ["Maharashtra", "Gujarat", "Delhi", "Rajasthan", "Karnataka"];
const ProfileDetail = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Saved Data:", formData);
  };
  const [formData, setFormData] = useState({
    name: "Manisha Subhanker",
    countryCode: "+44",
    mobile: "95636 98563",
    age: "26",
    occupation: "UI UX Designer",
    state: "Maharashtra",
    pincode: "360001",
  });

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };
  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack spacing={2.4}>
        <Box>
          <Typography
            sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
          >
            Name
          </Typography>
          <TextField
            fullWidth
            value={formData.name}
            onChange={handleChange("name")}
            size="small"
          />
        </Box>

        <Box>
          <Typography
            sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
          >
            Enter Mobile Number
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={formData.mobile}
            onChange={handleChange("mobile")}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ fontSize: "1rem" }}>🇬🇧</Typography>
                    <Typography sx={{ fontSize: "0.95rem", color: "#111" }}>
                      {formData.countryCode}
                    </Typography>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ height: 20, alignSelf: "center" }}
                    />
                  </Stack>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
          >
            Age
          </Typography>
          <TextField
            fullWidth
            value={formData.age}
            onChange={handleChange("age")}
            size="small"
          />
        </Box>

        <Box>
          <Typography
            sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
          >
            Occupation{" "}
            <Box component="span" sx={{ color: "#999", fontWeight: 400 }}>
              (Optional)
            </Box>
          </Typography>
          <TextField
            fullWidth
            value={formData.occupation}
            onChange={handleChange("occupation")}
            size="small"
          />
        </Box>

        <Box>
          <Typography
            sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
          >
            State{" "}
            <Box component="span" sx={{ color: "#999", fontWeight: 400 }}>
              (Optional)
            </Box>
          </Typography>
          <TextField
            select
            fullWidth
            value={formData.state}
            onChange={handleChange("state")}
            size="small"
            SelectProps={{
              IconComponent: KeyboardArrowDownOutlinedIcon,
            }}
          >
            {states.map((state) => (
              <MenuItem key={state} value={state}>
                {state}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <Box>
          <Typography
            sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
          >
            Pincode{" "}
            <Box component="span" sx={{ color: "#999", fontWeight: 400 }}>
              (Optional)
            </Box>
          </Typography>
          <TextField
            fullWidth
            value={formData.pincode}
            onChange={handleChange("pincode")}
            size="small"
          />
        </Box>

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            mt: 1,
            bgcolor: "#000",
            color: "#fff",
            textTransform: "none",
            borderRadius: 2,
            py: 1.4,
            fontWeight: 500,
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#111",
              boxShadow: "none",
            },
          }}
        >
          Save Changes
        </Button>
      </Stack>
    </Box>
  );
};

export default ProfileDetail;
